const medicalFormData = [
    {id: 1, title: "بیماری کرونری قلب", label: "coronary_heart_disease", answer: false},
    {id: 2, title: "کم خونی", label: "anemia", answer: false},
    {id: 3, title: "درد در ناحیه شانه و آرواره", label: "shoulder_pain", answer: false},
    {id: 4, title: "بی نظمی ضربان قلب", label: "heart_rhythm", answer: false},
    {id: 5, title: "فشار خون بالا", label: "high_blood_pressure", answer: false},
    {id: 6, title: "کوتاهی تنفس", label: "asthma", answer: false},
    {id: 7, title: "سابقه خانوادگی بیماری قلبی", label: "heart_condition_history", answer: false},
    {id: 8, title: "تب روماتیسمی", label: "rheumatic_fever", answer: false},
    {id: 9, title: "میزان کلسترول بالا", label: "high_cholesterol", answer: false},
    {id: 10, title: "مصرف دخانیات و مشروبات الکلی", label: "drug_alcohol", answer: false},
    {id: 11, title: "دیابت", label: "diabetes", answer: false},
    {id: 12, title: "گیجی یا کاهش هوشیاری", label: "decreased_consciousness", answer: false},
    {id: 13, title: "حمله ناگهانی یا تشنج", label: "convulsions", answer: false},
    {id: 14, title: "انواع سردرد ها", label: "headache", answer: false},
    {id: 15, title: "عمل جراحی", label: "surgery", answer: false},
    {id: 16, title: "آسیب جدی استخوان یا مفصل", label: "broken_bone", answer: false},
    {id: 17, title: "کمردرد", label: "backache", answer: false}
];

export default medicalFormData;